import styled from "styled-components";

export const Container = styled.button`
  background-color: transparent;
  border: none;
  color: var(--details-color);
  font-size: 2rem;
`;
